import React from 'react';

const Testimonial = ({ name, feedback }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <p className="text-lg italic mb-4">"{feedback}"</p>
      <h3 className="text-blue-800 font-bold text-xl">- {name}</h3>
    </div>
  );
};

export default Testimonial;
